module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/react-stickynode/~/core-js/internals/fails.js
// module id = 16
// module chunks = 0